import {
  RegistrationParams,
  registration,
  login,
  lostPassword,
  WebLoginParams,
  userConfirmation,
  ConfirmationParams,
  userUpdate,
  UserUpdateParams,
  UserCancelationParams,
  resetPassword,
  userCancelation,
  userConfirmationResend,
  ResetPasswordParams,
  ConfirmationResendParams,
  LostPasswordParams,
  getInstagramPosts,
  GetInstagramPostsResponse,
  getLoggedInWebUser,
  getProductDownloads,
  GetProductDownloadsParams,
  ProductDownloadsResponse,
  postTechnicalTraining,
  PostTechnicalTrainingParams,
  postProjectRegistration,
  PostProjectRegistrationParams,
  postRmaEmail,
  PostRmaEmailParams,
  WebRegistrationResponse,
  WebUserUpdateResponse,
  getSupportPageData,
  GetSupportPageDataResponse,
} from "@robe/core-api/web";
import { BaseApiRequest } from "@robe/core-api";
import { WebUser } from "@robe/core-types/web";
import { XcoreCore } from "XcoreCore";

// TODO: timeout option is just a temporary fix for SEA long fetch response times
export class XcoreWeb {
  private core: XcoreCore;

  public constructor(core: XcoreCore) {
    this.core = core;
  }

  /**
   * @throws {WebRegistrationError}
   */
  public registration(params: RegistrationParams): BaseApiRequest<WebRegistrationResponse> {
    return registration(this.core, params);
  }

  /**
   * @throws {WebLoginError}
   */
  public login(params: WebLoginParams): BaseApiRequest<WebUser> {
    return login(this.core, params);
  }

  public getLoggedInWebUser(): BaseApiRequest<WebUser | null> {
    return getLoggedInWebUser(this.core);
  }

  /**
   * @throws {WebUserUpdateError}
   */
  public userUpdate(params: UserUpdateParams): BaseApiRequest<WebUserUpdateResponse> {
    return userUpdate(this.core, params);
  }

  /**
   * @throws {WebUserConfirmationError}
   */
  public userConfirmation(params: ConfirmationParams, timeout?: number): BaseApiRequest<Response> {
    return userConfirmation(this.core, params, timeout);
  }

  /**
   * @throws {WebUserConfirmationResendError}
   */
  public userConfirmationResend(params: ConfirmationResendParams, timeout?: number): BaseApiRequest<Response> {
    return userConfirmationResend(this.core, params, timeout);
  }

  /**
   * @throws {WebLostPasswordError}
   */
  public lostPassword(params: LostPasswordParams): BaseApiRequest<Response> {
    return lostPassword(this.core, params);
  }

  /**
   * @throws {WebResetPasswordError}
   */
  public resetPassword(params: ResetPasswordParams): BaseApiRequest<Response> {
    return resetPassword(this.core, params);
  }

  /**
   * @throws {WebUserCancelationError}
   */
  public userCancelation(params: UserCancelationParams): BaseApiRequest<Response> {
    return userCancelation(this.core, params);
  }

  public getInstagramPosts(timeout?: number): BaseApiRequest<GetInstagramPostsResponse> {
    return getInstagramPosts(this.core, timeout);
  }

  public postProjectRegistration(params: PostProjectRegistrationParams, timeout?: number): BaseApiRequest<any> {
    return postProjectRegistration(this.core, params, timeout);
  }

  public postRmaEmail(params: PostRmaEmailParams, timeout?: number): BaseApiRequest<Response> {
    return postRmaEmail(this.core, params, timeout);
  }

  public getProductDownloads(params: GetProductDownloadsParams, timeout?: number): BaseApiRequest<ProductDownloadsResponse> {
    return getProductDownloads(this.core, params, timeout);
  }

  public postTechnicalTraining(params: PostTechnicalTrainingParams): BaseApiRequest<Response> {
    return postTechnicalTraining(this.core, params);
  }

  public getSupportPageData(): BaseApiRequest<GetSupportPageDataResponse> {
    return getSupportPageData(this.core);
  }
}
